import { z } from "zod";

/**
 * Versão vigente dos Termos de Uso e da Política de Privacidade, publicados juntos (minutas em
 * docs/juridico/). `null` = ainda não publicados: o cadastro não grava aceite e ninguém é parado.
 * Trocar a versão faz quem já tem conta aceitar de novo na próxima entrada.
 */
export const VERSAO_DOS_DOCUMENTOS: string | null = null;

/** Endereços das páginas no site (apps/web), relativos à origem do site. */
export const PAGINAS_DOS_DOCUMENTOS = { termos: "/termos", privacidade: "/privacidade" } as const;

/** Falta aceitar a versão vigente? Sem versão vigente, nunca falta. */
export function aceitePendente(vigente: string | null, versoesAceitas: readonly string[]) {
  return vigente !== null && !versoesAceitas.includes(vigente);
}

export const aceitarDocumentosSchema = z.object({ versao: z.string().trim().min(1).max(40) });
export type AceitarDocumentosInput = z.infer<typeof aceitarDocumentosSchema>;
